var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossInCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cross-in-circle 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Work-order",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MVP-Home-Page---1-permit-rejected",
    transform: "translate(-32.000000, -273.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cross-in-circle-2",
    transform: "translate(32.000000, 273.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cross-in-circle"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,20 C15.5228475,20 20,15.5228475 20,10 C20,4.4771525 15.5228475,0 10,0 C4.4771525,0 0,4.4771525 0,10 C0,15.5228475 4.4771525,20 10,20 Z M10,18.1818182 C5.48130659,18.1818182 1.81818182,14.5186934 1.81818182,10 C1.81818182,5.48130659 5.48130659,1.81818182 10,1.81818182 C14.5186934,1.81818182 18.1818182,5.48130659 18.1818182,10 C18.1818182,14.5186934 14.5186934,18.1818182 10,18.1818182 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70848863,6.93463473 L13.0653653,14.2915114 C13.4039562,14.6301023 13.9529205,14.6301023 14.2915114,14.2915114 C14.6301023,13.9529205 14.6301023,13.4039562 14.2915114,13.0653653 L6.93463473,5.70848863 C6.59604384,5.36989773 6.04707953,5.36989773 5.70848863,5.70848863 C5.36989773,6.04707953 5.36989773,6.59604384 5.70848863,6.93463473 Z",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.06744,5.70813266 L5.70813266,13.06744 C5.37001639,13.4055563 5.37001639,13.9537511 5.70813266,14.2918673 C6.04624893,14.6299836 6.59444371,14.6299836 6.93255998,14.2918673 L14.2918673,6.93255998 C14.6299836,6.59444371 14.6299836,6.04624893 14.2918673,5.70813266 C13.9537511,5.37001639 13.4055563,5.37001639 13.06744,5.70813266 Z",
    id: "Line"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossInCircle);
export default __webpack_public_path__ + "static/media/CrossInCircle.16ca96cca748b0bb1867d586713c1ae5.svg";
export { ForwardRef as ReactComponent };